<template>
    <div v-if="can('schedules.index')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Transportation organization')}}</a></router-link>
                <router-link to="/schedules" tag="li" class="breadcrumb-item"><a href="">{{i18n('Flights schedule')}}</a></router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <h1 class="title">{{i18n('Schedule trips')}}</h1>
            </div>
            <div class="base_box_cnt">
                <div class="row">
                    <div class="col-md-8 col-sm-12 col-12">
                        <div class="button-group">
                            <router-link v-if="can('schedules.create')" to="/schedule-new">
                                <button class="btn base_btn solid_blue waves-effect waves-light">{{i18n('Create')}}</button>
                            </router-link>
                            <button v-if="selectedSchedule.id && selectedSchedule.status === 10 && can('schedules.cancel')" @click='deactivateSchedule' class="btn base_btn solid_blue waves-effect waves-light">
                                Деактивировать
                            </button>
                            <button v-if="selectedSchedule.id && selectedSchedule.status !== 10 && can('schedules.activate')" @click='activateSchedule' class="btn base_btn solid_blue waves-effect waves-light">
                                Активировать
                            </button>
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-12 col-12 d-none">
                        <form action="" class="search">
                            <div class="base_input_bx">
                                <input type="text" class="form-control base_input" :placeholder="i18n('Filter')">
                                <i class="mdi mdi-magnify"></i>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_cnt pb-0 form-inline">
            <div class="form-inline mr-5">
                <label for="from" class="col-form-label fs-12 mr-3">{{i18n('Point of departure')}}:</label>
                <input type="text" class="form-control" id="from" @keyup="filterSchedules(true)" v-model="from">
            </div>

            <div class="form-inline">
                <label class="col-form-label fs-12 mr-3" for="to">{{i18n('Destination')}}:</label>
                <input type="text" class="form-control" id="to" @keyup="filterSchedules(false)" v-model="to">
            </div>

            <!--<div>
                <label class="col-form-label fs-12 mr-3" for="to">{{i18n('Status')}}:</label>
                <select id="userstatus" v-model="status" class="custom-select w-50">
                    <option :value="status.id" v-for="status in user_status">{{ status.name }}</option>
                </select>
            </div>-->

        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">
                                    <button class="w-100 text-left" type="button">{{i18n('Routes')}} <span class="float-right"><i class="mdi mdi-arrow-up"></i></span></button>
                                </th>
                                <th scope="col">{{i18n('Departure time')}}</th>
                                <th scope="col">{{i18n('Transporter')}}</th>
                                <th scope="col">{{i18n('Regularity')}}</th>
                                <th scope="col">{{i18n('Status')}}</th>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="schedule in schedulesFilter" @click="selectSchedule(schedule)" :class="{'bg-primary': schedule.id === selectedSchedule.id}">
                                <td>{{ schedule.route_name }}</td>
                                <td class="text-center">{{ schedule.begin_at | moment("HH:mm") }}</td>
                                <td class="text-center">{{ schedule.transporter }}</td>
                                <td class="text-center">
                                    {{ $store.getters.getRegularity(schedule.trip_regularity_type) }}
                                </td>
                                <td class="text-center">
                                    <p class="badge badge-success" v-if="schedule.status === 10">{{i18n('Active')}}</p>
                                    <p class="badge badge-danger" v-else>Выключено</p>
                                </td>
                                <td class="text-center">
                                    <router-link v-if="can('schedules.edit')" :to="'/schedule-new/' + schedule.id" class="btn-icon">
                                        <i class="mdi mdi-pencil text-primary"></i>
                                    </router-link>
                                    <button v-if="can('schedules.delete')" type="button" class="btn-icon" @click="deleteItem(schedule)">
                                        <i class="mdi mdi-minus-circle text-danger"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <pagination :links="links" :url="'schedules'"></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../../components/Pagination";
    export default {
        components: {Pagination},
        data() {
            return {
                schedules: [],
                schedulesFilter: [],
                from: '',
                to: '',
                selectedSchedule: {},
                links: {},
                page: 1
            }
        },
        created() {
            this.loadSchedule();
            this.$api.get('schedule-trips.regularity-types')
                .then(res => {
                    this.$store.commit('setRegularityTypes', res.data);
                });
        },
        methods: {
            loadSchedule() {
                this.$api.get('schedule-trips.index', {
                                page: this.page,
                                from: this.from,
                                to: this.to
                    })
                    .then(res => {
                        this.schedulesFilter = res.data;
                        this.links = res.links;
                        // this.filterSchedules(false);
                    });
            },
            deactivateSchedule() {
                this.$api.get('schedule-trips.deactivate', this.selectedSchedule.id)
                    .then(res => {
                        if (!res.errors) {
                            this.schedulesFilter.find(item => {
                                if (item.id === this.selectedSchedule.id) {
                                    item.status = res.data.status;
                                }
                            });
                        }
                    })
            },
            activateSchedule() {
                this.$api.get('schedule-trips.activate', this.selectedSchedule.id)
                    .then(res => {
                        if (!res.errors) {
                            this.schedulesFilter.find(item => {
                                if (item.id === this.selectedSchedule.id) {
                                    item.status = res.data.status;
                                }
                            });
                        }
                    })
            },
            selectSchedule(item) {
                this.selectedSchedule = item;
            },
            filterSchedules(fromBegin) {
                this.page = 1;
                this.loadSchedule();
            },
            deleteItem(item) {
                if (confirm(this.i18n('Do you really want to delete flight schedules?'))) {
                    this.$api.delete('schedule-trips.delete', item.id)
                        .then(res => {
                            if (!res.errors) {
                                let indx = this.schedulesFilter.indexOf(item);
                                this.schedulesFilter.splice(indx, 1);
                                this.$store.commit('successNotify')();
                            }
                        })
                }
            }
        },
        mounted() {
            $('.selectpicker').selectpicker();
        },
        beforeRouteUpdate(to, from, next) {
            let page = to.params.page;
            if (page) {
                this.page = page;
                this.loadSchedule();
            }
            next();
        }
    }
</script>

<style>
    .table-hover tbody tr.bg-primary:hover {
        background-color: #007bff !important;
        color: #ffffff !important;
    }
</style>
